const tourBoundariesEndpoints = {
  base: "/v1/cms/tour-boundaries",
  byTour: (tourId) =>
    `/v1/cms/tour-boundaries?tourId=${encodeURIComponent(String(tourId || ""))}`,
};

export default tourBoundariesEndpoints;

